import { Skeleton, Typography } from 'antd';
import { useGetManyCargos } from 'api/cargos/use-get-many-cargos';
import { WhInfoCargoCard } from 'components/wh-info/wh-info-cargo-card';
import type { IWhInfoCargoesGroupProps } from './types';
import styles from './wh-info-cargoes-group.module.scss';

export const WhInfoCargoesGroup: React.FC<IWhInfoCargoesGroupProps> = (props) => {
  const { filters, title } = props;
  const { data: cargos, isLoading } = useGetManyCargos({ filters, includeFromStatuses: true });

  const hasCargos = cargos?.data && cargos.data.length > 0;

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <div className={styles.groupContainer}>
      <Typography.Title level={4} className={styles.groupTitle}>
        {title}
      </Typography.Title>

      {hasCargos ? (
        <div>
          {cargos.data.map((cargo) => (
            <WhInfoCargoCard key={cargo.id} cargo={cargo} />
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📦</div>
          <Typography.Text>No cargos to display</Typography.Text>
        </div>
      )}
    </div>
  );
};
